import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { DomainConnectFetchSetupResponse } from 'owa-domain-connect';

export function traceManageDomainButtonClick() {
    logUsage(
        datapoints.DomainDashboardManageDomain.datapoint.name,
        null,
        datapoints.DomainDashboardGetStarted.datapoint.options
    );
}

export function traceRemoveDomainButtonClick() {
    logUsage(
        datapoints.DomainDashboardRemoveDomain.datapoint.name,
        null,
        datapoints.DomainDashboardGetStarted.datapoint.options
    );
}

export function traceCreateEmailButtonClick() {
    logUsage(
        datapoints.DomainDashboardCreateEmail.datapoint.name,
        null,
        datapoints.DomainDashboardGetStarted.datapoint.options
    );
}

export function traceStartEnrollDomainClick() {
    logUsage(
        datapoints.DomainDashboardGetStarted.datapoint.name,
        null,
        datapoints.DomainDashboardGetStarted.datapoint.options
    );
}

export function traceDomainStatus(message: DomainConnectFetchSetupResponse) {
    logUsage(
        datapoints.DomainDashboarDomainStatus.datapoint.name,
        datapoints.DomainDashboarDomainStatus.datapoint.customData(
            message.domainData.dnsRecordValue,
            message.domainData.domainName,
            message.domainData.isDomainValidated,
            message.domainData.isDomainExisted,
            message.domainData.domainPurchaseType.toString(),
            message.domainData.domainPurchaseDate.toString()
        ),
        datapoints.DomainDashboarDomainStatus.datapoint.options
    );
}

export function traceDomainUIStatue(isAliasAdded: boolean, uiState: string) {
    logUsage(
        datapoints.DomainDashboarDomainUIStatus.datapoint.name,
        datapoints.DomainDashboarDomainUIStatus.datapoint.customData(isAliasAdded, uiState),
        datapoints.DomainDashboarDomainUIStatus.datapoint.options
    );
}

export function traceSecondaryUserEmailRemoveButtonClick() {
    logUsage(
        datapoints.DomainDashboarRemoveSecondaryUserEmail.datapoint.name,
        null,
        datapoints.DomainDashboarRemoveSecondaryUserEmail.datapoint.options
    );
}
